import React, { useRef, useState,useEffect} from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { handleFileUpload } from "../../utils/ImageToBase64";
import { useDispatch, useSelector } from "react-redux";
import { getStaffs, getStaffsByOrgId, sendUserMessage, updateMessage } from "../../api/User";
import { platformLayout } from "../../utils/constants";
import { failed, success } from "../../utils/Tostify";
import Loader from "../../components/Loader/Loader";
import { decryptData } from "../../utils/helper";
import { Autocomplete, TextField } from "@mui/material";
import { getPatientById, getPatients } from "../../api/patient";
import { decryptPatientData } from "../../utils/common";
import { getAllApplication } from "../../api/Applications";

const ComposeMessage = ({ isOpen, toggle,draftMessage,fetchMessages, folder}) => {
  const fileInputRef = useRef(null);
  const [attachments, setAttachments] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [patientList, setPatientList] = useState([]);
  const [applicationList, setApplicationlist] = useState([]);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userReducer.token);
  let user = useSelector(state => state.userReducer.user);
  let role = localStorage.getItem("userRole");
  const [isLoading, setIsLoading] = useState(false);
  const [filterApplicationList, setFilteredApplicationList] = useState([]);
  useEffect(() => {
    if (draftMessage) {
      formik.setValues({
        to: draftMessage.to?._id || null,
        patient: typeof draftMessage.patient === "object" ? draftMessage.patient?._id : draftMessage.patient || null,
        applicationId: typeof draftMessage.applicationId === "object" ? draftMessage.applicationId?._id : draftMessage.applicationId || "",
        cc: Array.isArray(draftMessage.cc) ? draftMessage.cc.join(", ") : draftMessage.cc || "",
        bcc: Array.isArray(draftMessage.bcc) ? draftMessage.bcc.join(", ") : draftMessage.bcc || "",
        subject: draftMessage.subject || "",
        content: draftMessage.content || ""
      });

      if (draftMessage.attachments && draftMessage.attachments.length > 0) {
        setAttachments(draftMessage.attachments); // Store remote attachments properly
      } else {
        setAttachments([]);
      }
    }
  }, [draftMessage]);

  const validationSchema = Yup.object().shape({
    to: Yup.string().nullable(),
    patient: Yup.string().nullable(),
    subject: Yup.string().required("Subject is required"),
    content: Yup.string().required("Message content is required")
  }).test("to-or-patient", "Either 'To Team Member' or 'Patient' must be provided", function (values) {
    const { to, patient } = values;

    if (!to && !patient) {
      return this.createError({
        path: "to",
        message: "Either 'To Team Member' or 'To Patient' is required"
      }) || this.createError({
        path: "patient",
        message: "Either 'To Team Member' or 'To Patient' is required"
      });
    }

    return true;
  });

  const formik = useFormik({
    initialValues: {
      to: null,
      patient:null,
      applicationId:null,
      cc: "",
      bcc: "",
      subject: "",
      content: ""
    },
    validationSchema,
    onSubmit: async (values) => {
      handleSubmitMessage({values,sentStatus:false});
  }});

  const getUsersList = async (page = 1, limit = 10, searchKey = "") => {
      let res;
      let responseData;
      try {
        if(role == platformLayout.Organization){
        res = await getStaffsByOrgId({dispatch, token, page, limit, searchKey, orgId: localStorage.getItem("currentOrgId"), currentHospitalId : localStorage.getItem("currentHospitalId")});
        responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
          setTeamMembers(
            responseData?.items.filter((item) => item?.active !== false && item?._id !== user?._id).map((obj) => ({
              label: obj?.firstName + " " + obj?.lastName,
              value: obj?._id
            }))
          );
        }
      }else if(role == platformLayout.Platform){
          res = await getStaffs({ dispatch, token, page, limit, searchKey});
          responseData = decryptData(res?.data);
          if (res?.status === "SUCCESS") {
            setTeamMembers(
              responseData?.items.filter((item) => item?.active !== false && item?._id !== user?._id).filter((item) =>
              item?.roleDetails?.some(role =>
                role.portalLayout === platformLayout.Platform && role.active
              )
            ).map((obj) => ({
                label: obj?.firstName + " " + obj?.lastName,
                value: obj?._id
              }))
            );
          }
        }else if(role == platformLayout.Patient){
          setIsLoading(true);
          res = await getPatientById({ dispatch, token, id: user?._id, userId : user?._id });
          const responseData = decryptData(res.data);
          const decryptedPatient =await decryptPatientData(responseData);
          const inProcessApplications = decryptedPatient?.applications?.filter(app => app.status === "InProcess");
          const consultants = inProcessApplications?.flatMap(app => app?.consultantUser || []);
          setTeamMembers(
            consultants.map((obj) => ({
              label: obj?.firstName + " " + obj?.lastName,
              value: obj?._id
          })));
        }
      } catch (error) {
        failed(res?.message);
      }
    };

    const getPatientList = async () => {
      let res;
      try {
        res = await getPatients({
          dispatch,
          token,
          listFilter: "all",
          orgId: localStorage.getItem("currentOrgId"),
          clinicId: localStorage.getItem("currentHospitalId")
        });
        if (res?.status === "SUCCESS") {
          const responseData = decryptData(res.data);
          if (responseData?.list) {
            const decryptedPatients = await Promise.all(
              responseData.list.map(async (patient) => decryptPatientData(patient))
            );
            const filteredPatients = decryptedPatients.filter((patient) => patient?.isAccountCreated);
            setPatientList(
              filteredPatients.map((obj) => ({
                label: obj?.name?.text,
                value: obj?._id
              }))
            );
          }
        }
      } catch (error) {
        failed(res?.message);
      }
    };

      const getApplicationList = async () => {
        let res;
        try {
          setIsLoading(true);
          res = await getAllApplication({
            dispatch,
            token,
            listFilter: "InProcess",
            clinicId: localStorage.getItem("currentHospitalId")
          });
          if (res?.status === "SUCCESS") {
            const responseData = decryptData(res?.data);
            setApplicationlist(
              responseData?.list?.items.map((app) => ({
                label: app?.title,
                value: app?._id,
                patient: app?.patientData._id
              }))
            );
          }
          setIsLoading(false);
        } catch (error) {
          // console.error("Error fetching applications:", error);
          failed(res?.message);
          setIsLoading(false);
        }
      };

      const filterApplicationsByPatient = (patientId) => {
        const filteredApplications = applicationList.filter(
          (app) => String(app?.patient) === String(patientId)
        );
        setFilteredApplicationList(filteredApplications);
      };

      const handlePatientChange = (event, newValue) => {
        formik.setFieldValue("patient", newValue ? newValue.value : null);
        formik.setFieldValue("applicationId", null);
        filterApplicationsByPatient(newValue?.value || "");
      };

      useEffect(() => {
        getUsersList();
        getPatientList();
        getApplicationList();
      }, []);

      useEffect(() => {
        if (formik.values.patient && applicationList) {
          filterApplicationsByPatient(formik.values.patient);
        }
      }, [formik.values.patient,applicationList]);

  const handleSubmitMessage = async(data)=>{
    let attachmentData = [];

    if (attachments.length) {
      attachmentData = await Promise.all(
        attachments.map(async (file) => {

          const base64 = await handleFileUpload(file);
          const fileExtension = file?.type?.split("/")[1];
          return {
            base64String: base64,
            extension: fileExtension,
            name: file.name
          };
        })
      );
    }

    const payload = {
      ...data.values,
      attachments: attachmentData,
      senderId: user._id,
      senderType: role !== platformLayout.Patient ? "User" :"Patient"
    };

    try {
      let res;
      setIsLoading(true);
      if(draftMessage?.folder === "Drafts" && draftMessage?._id){
        res = await updateMessage({
          messageId: draftMessage._id,
          data: {...payload, portal: role, folder : data.sentStatus === true ? "Drafts" : "Sent"},
          dispatch,
          token
        });
      }else{
      const folder = data.sentStatus === true ? "Drafts" : "Sent";
      const values = {...payload,folder, portal: role };
      res = await sendUserMessage({ payload : values, dispatch, token});
      }
      if (res?.status === "SUCCESS") {
        setIsLoading(false);
        if(data.sentStatus === true){
          success("Draft Saved Successfully");
        }else{
          success(res?.message);
        }
        toggle();
        await fetchMessages(folder);
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
        setIsLoading(false);
    }
  };

  const toggleWithDraft = async () => {
    handleSubmitMessage({values:formik.values,sentStatus:true});
    formik.resetForm();
    toggle(); // Close the modal
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setAttachments((prevFiles) => [...prevFiles, ...files]);
  };


  const isImageFile = (file) => {
    if (file.publicUrl) {
      return file.publicUrl.endsWith(".png") || file.publicUrl.endsWith(".jpg") || file.publicUrl.endsWith(".jpeg") || file.publicUrl.endsWith(".gif");
    }
    return file.name && (file.name.endsWith(".png") || file.name.endsWith(".jpg") || file.name.endsWith(".jpeg") || file.name.endsWith(".gif"));
  };

  return (
    <div>{isLoading && <Loader/>}
    <Modal isOpen={isOpen} toggle={toggleWithDraft} size="xl">
      <ModalHeader toggle={toggleWithDraft} className="assign_blk p-0 mb-3">
        Compose Message
      </ModalHeader>
      <ModalBody className="px-3">
        <form onSubmit={formik.handleSubmit}>
        <FormGroup>
            <Label htmlFor="to">To Team Member:</Label>
            <Autocomplete
              id="to"
              options={teamMembers}
              getOptionLabel={(option) => option.label}
              value={teamMembers.find((option) => option.value === formik.values.to) || null}
              onChange={(event, newValue) => {
                formik.setFieldValue("to", newValue ? newValue.value : null);
              }}
              onBlur={() => formik.setFieldTouched("to", true)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select recipient"
                  error={formik.touched.to && Boolean(formik.errors.to)}
                />
              )}
            />
            {formik.touched.to && formik.errors.to && (
              <div className="text-danger">{formik.errors.to}</div>
            )}
          </FormGroup>

          {role === platformLayout.Organization && <>
          <FormGroup>
            <Label htmlFor="patient">To Patient:</Label>
            <Autocomplete
              id="patient"
              options={patientList}
              getOptionLabel={(option) => option.label}
              value={patientList.find((option) => option.value === formik.values.patient) || null}
              onChange={handlePatientChange}  // Here we use it!
              onBlur={() => formik.setFieldTouched("patient", true)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select recipient"
                  error={formik.touched.patient && Boolean(formik.errors.patient)}
                />
              )}
            />
            {formik.touched.patient && formik.errors.patient && (
              <div className="text-danger">{formik.errors.patient}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label htmlFor="applicationId">Application Ref:</Label>
            <Autocomplete
              id="applicationId"
              options={filterApplicationList}
              getOptionLabel={(option) => option.label}
              value={applicationList.find((option) => option.value === formik.values.applicationId) || null}
              onChange={(event, newValue) => {
                formik.setFieldValue("applicationId", newValue ? newValue.value : null );
              }}
              onBlur={() => formik.setFieldTouched("applicationId", true)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select application"
                  error={formik.touched.applicationId && Boolean(formik.errors.applicationId)}
                />
              )}
            />
            {formik.touched.applicationId && formik.errors.applicationId && (
              <div className="text-danger">{formik.errors.applicationId}</div>
            )}
          </FormGroup></>}

          <FormGroup>
            <Label htmlFor="subject">Subject</Label>
            <Input
              type="text"
              name="subject"
              id="subject"
              placeholder="Enter subject"
              value={formik.values.subject}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.subject && formik.errors.subject && (
              <div className="text-danger">{formik.errors.subject}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label htmlFor="content">Message</Label>
            <Input
              type="textarea"
              name="content"
              rows={4}
              id="content"
              placeholder="Enter your message"
              value={formik.values.content}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.content && formik.errors.content && (
              <div className="text-danger">{formik.errors.content}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="attachment">
              Attachment{" "}
              <span className="material-symbols-outlined file_upload">
                attach_file
              </span>
            </Label>
            <input
              id="attachment"
              name="attachment"
              type="file"
              style={{ display: "none" }}
              accept="image/*,application/pdf"
              ref={fileInputRef}
              onChange={handleFileChange}
              multiple
            />
          </FormGroup>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
            {attachments.map((file, index) => (
              <div key={index} style={{ textAlign: "center" }}>
                {file.publicUrl ? ( // If it's a remote file from draft
                  isImageFile(file) ? (
                    <img
                      src={file.publicUrl} // Use remote URL directly
                      alt="Attachment Preview"
                      style={{ width: "100px", height: "100px", objectFit: "cover" }}
                    />
                  ) : (
                    <a href={file.publicUrl} target="_blank" rel="noopener noreferrer">
                      {file.fileName || "Download Attachment"}
                    </a>
                  )
                ) : (
                  isImageFile(file) ? (
                    <img
                      src={URL.createObjectURL(file)} // Use object URL for new uploads
                      alt="Attachment Preview"
                      style={{ width: "100px", height: "100px", objectFit: "cover" }}
                    />
                  ) : (
                    <p>{file.name}</p>
                  )
                )}
              </div>
            ))}
          </div>

          <ModalFooter>
            <Button color="primary" type="submit">
              Send
            </Button>
          </ModalFooter>
        </form>
      </ModalBody>
    </Modal>
    </div>
  );
};

export default ComposeMessage;
